import { render, staticRenderFns } from "./addTaxno.vue?vue&type=template&id=bc0aa61a&scoped=true&"
import script from "./addTaxno.vue?vue&type=script&lang=js&"
export * from "./addTaxno.vue?vue&type=script&lang=js&"
import style0 from "./addTaxno.vue?vue&type=style&index=0&id=bc0aa61a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0aa61a",
  null
  
)

export default component.exports